import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ae0f30f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "multi-option-picker" }
const _hoisted_2 = { class: "search-container" }
const _hoisted_3 = { class: "option-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "option-label" }
const _hoisted_6 = {
  key: 0,
  class: "not-checked"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "10",
  viewBox: "0 0 14 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 5.49943L4.65259 9L13 1",
    stroke: "#2E5BFF",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchBox = _resolveComponent("SearchBox")!
  const _component_AvatarOrInitials = _resolveComponent("AvatarOrInitials")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SearchBox, {
        value: _ctx.searchText,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchText = $event))
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOptions, (opt, optIdx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: optIdx,
          class: "option",
          onClick: ($event: any) => (_ctx.onClickOption(opt))
        }, [
          (_ctx.withIcon)
            ? (_openBlock(), _createBlock(_component_AvatarOrInitials, {
                key: 0,
                class: "icon",
                size: 40,
                user: _ctx.mockUser(opt)
              }, null, 8, ["user"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, _toDisplayString(opt.label), 1),
          _createElementVNode("div", {
            class: _normalizeClass({ checkbox: true, selected: _ctx.isOptionSelected(opt) })
          }, [
            (!_ctx.isOptionSelected(opt))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
          ], 2)
        ], 8, _hoisted_4))
      }), 128))
    ])
  ]))
}